import { MY_EXIT_REQUESTS_REG, MY_EXIT_REQUESTS_EXPORT } from "@API/APIRoutes";
import GenericPendingExitRequests from "../GenericPendingExitRequests/GenericPendingExitRequests";

function MyPendingExitRequestsListing() {
  return <GenericPendingExitRequests API={MY_EXIT_REQUESTS_REG} exportApi={MY_EXIT_REQUESTS_EXPORT} title={"My Exit Requests"} all={false}/>;
}

export default MyPendingExitRequestsListing;
